module.exports = {"TXTWCL_OopsX_No_Games_Found":{"id":"TXTWCL_OopsX_No_Games_Found","defaultMessage":"Hoppá! Nincs ilyen játék"}}